export const observationTypes = {
  POSITIVE: {
    icon: 'mood',
    key: 'FALSE',
    title: 'Positive',
    color: 'green',
  },
  NEGATIVE: {
    icon: 'flag',
    key: 'TRUE',
    title: 'Action Rqd',
    color: 'red',
  },
};
export const observationStatus = {
  NEW: { key: 'NEW', title: 'New', color: 'blue' },
  IN_PROGRESS: {
    key: 'IN_PROGRESS',
    title: 'In Progress',
    color: 'yellow',
  },
  INVALID: { key: 'INVALID', title: 'Dismissed', color: 'red' },
  COMPLETE: { key: 'COMPLETE', title: 'Complete', color: 'green' },
  ESCALATED: { key: 'ESCALATED', title: 'Escalated', color: 'orange' },
};

export const observationClassificationTypes = [
  'Behavioural Observation',
  'Positive Observation',
  'Security Observation',
  'Hazard Identification',
  'Inspection Finding',
  'Near Miss',
  'Worker Recognition',
];
